import { render, staticRenderFns } from "./SettingsCard.vue?vue&type=template&id=9e189cba&scoped=true&"
import script from "./SettingsCard.vue?vue&type=script&lang=js&"
export * from "./SettingsCard.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCard.vue?vue&type=style&index=0&id=9e189cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e189cba",
  null
  
)

export default component.exports